export default __webpack_public_path__ + "static/media/hoodiesmen.190c0f04.jpg";